import React from "react";
import moment from "moment";

const formatDate = (date) => {
  if (!date) {
    return "-";
  }
  const parsed = moment(date, ["M/D/YYYY", "MM/DD/YYYY", "YYYY-MM-DD"], true);
  return parsed.isValid() ? parsed.format("MMM DD, YYYY") : date;
};

const getDateTime = (date) => {
  const parsed = moment(date, ["M/D/YYYY", "MM/DD/YYYY", "YYYY-MM-DD"], true);
  return parsed.isValid() ? parsed.valueOf() : 0;
};

const Filings = ({ data }) => {
  const filings = (data && data.filings ? data.filings : [])
    .slice()
    .sort((a, b) => getDateTime(b.filing_date) - getDateTime(a.filing_date))
    .slice(0, 100);

  if (!filings.length) {
    return <div className="text-center p-5">No filings available.</div>;
  }

  return (
    <div className="mi-regulatory-table-wrap mt-4 px-3">
      <div className="table-responsive mi-regulatory-table-scroll">
        <table className="table mi-regulatory-table mi-filings-table">
          <thead>
            <tr>
              <th>Filing Date</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {filings.map((item) => {
              const viewUrl = item.document_url || item.filing_url;
              const description = item.description || item.form || "-";
              return (
                <tr key={item.id || `${item.filing_date}-${item.filing_url}`}>
                  <td>{formatDate(item.filing_date)}</td>
                  <td>
                    <span>{description}</span>
                    {viewUrl ? (
                      <>
                        {" "}
                        <a href={viewUrl} target="_blank" rel="noopener noreferrer">
                          (view)
                        </a>
                      </>
                    ) : (
                      <></>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Filings;
